import { memo } from 'react'
import { MapPinIcon } from '@heroicons/react/24/outline'
import LocationPickerMap from '../../../../components/sighting/LocationPickerMap'
import { getInputClasses, labelClasses } from '../../../../styles/inputStyles'

/**
 * LocationFields - Location picker and address fields
 * Handles current location selection with map picker
 */
const LocationFields = memo(function LocationFields({
  formData,
  validationErrors,
  onInputChange,
  showMapPicker,
  setShowMapPicker,
  mapPosition,
  setMapPosition,
  handleLocationSelect
}) {
  return (
    <div className="border-t pt-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        <MapPinIcon className="h-5 w-5 inline mr-1" />
        Current Location
      </h3>

      {/* Map Picker Toggle */}
      <div className="mb-4">
        <button
          type="button"
          onClick={() => setShowMapPicker(!showMapPicker)}
          className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-600 transition-colors"
        >
          {showMapPicker ? 'Hide Map' : 'Pick Location on Map'}
        </button>
      </div>

      {/* Map Picker */}
      {showMapPicker && (
        <div className="mb-6">
          <LocationPickerMap
            position={mapPosition}
            onLocationSelect={handleLocationSelect}
            zoom={13}
          />
        </div>
      )}

      {/* Address Field */}
      <div className="grid grid-cols-1 gap-6">
        <div>
          <label htmlFor="currentAddress" className={labelClasses}>
            Address
          </label>
          <input
            type="text"
            id="currentAddress"
            value={formData.currentAddress}
            onChange={(e) => onInputChange('currentAddress', e.target.value)}
            className={getInputClasses() + ' px-4 py-2'}
            placeholder="123 Main St, City, ST 12345"
          />
        </div>

        {/* Coordinates (Read-only) */}
        {formData.currentLatitude && formData.currentLongitude && (
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className={labelClasses}>
                Latitude
              </label>
              <input
                type="text"
                value={formData.currentLatitude.toFixed(6)}
                disabled
                className={`${getInputClasses()} bg-gray-50`}
              />
            </div>
            <div>
              <label className={labelClasses}>
                Longitude
              </label>
              <input
                type="text"
                value={formData.currentLongitude.toFixed(6)}
                disabled
                className={`${getInputClasses()} bg-gray-50`}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
})

export default LocationFields
